module.exports = __webpack_public_path__ + "static/media/criacao-elementos-img-03.2b15b0c0.svg";